import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Scanlines } from "./components/common";
import Login from "./pages/Login";
import GMDashboard from "./pages/GMDashboard";
import GMConsole from "./pages/GMConsole";
import PlayerHome from "./pages/PlayerHome";
import PlayerApp from "./pages/PlayerApp";
import InvitePage from "./pages/InvitePage";

function Loading() {
  return (
    <div className="h-full flex items-center justify-center">
      <span className="font-mono text-xs tracking-[0.3em] text-[color:var(--r-primary)] blink">
        CONNEXION AU NODE…
      </span>
    </div>
  );
}

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "gm" ? "/gm" : "/play"} replace />;
}

function Protected({ role, children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <Scanlines />
      <AuthProvider>
        <ThemeProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<RootRedirect />} />
              <Route path="/login" element={<Login />} />
              <Route path="/invite/:token" element={<InvitePage />} />
              <Route path="/gm" element={<Protected role="gm"><GMDashboard /></Protected>} />
              <Route path="/gm/campaign/:cid" element={<Protected role="gm"><GMConsole /></Protected>} />
              <Route path="/play" element={<Protected role="player"><PlayerHome /></Protected>} />
              <Route path="/play/:cid" element={<Protected role="player"><PlayerApp /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </AuthProvider>
    </div>
  );
}
